// const api = "https://quality.nochemadrid.org/api/";
const api = "https://apiquality.fiestaismadrid.net/";
// const api = 'http://localhost:8000/';
const varAdmin = "administrators";
const varEncu = "encuestador";
const varOpe = "operador";
export { api, varAdmin, varEncu, varOpe };
